import { render, staticRenderFns } from "./MotivodeBajaPantalla.vue?vue&type=template&id=2af4bb1b&"
import script from "./MotivodeBajaPantalla.vue?vue&type=script&lang=ts&"
export * from "./MotivodeBajaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports